import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import { getItemLinkFieldValue } from '@core/jss-utils';
import { InnogyComponentRendering } from '@core/jss-models';
import { NgClass } from '@angular/common';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';

@Component({
  selector: 'wl-colset12',
  templateUrl: './colset12.component.html',
  styleUrls: [
    './colset12.component.ed.scss',
    './colset12.component.essent.scss',
  ],
  host: { ngSkipHydration: 'true' },
  standalone: true,
  imports: [NgClass, JssModule],
})
export class Colset12Component implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rowSpacing?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() contentOptions?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;

  ngOnInit() {
    this.renderingToModel(this.rendering);
  }

  private renderingToModel(rendering: InnogyComponentRendering | undefined) {
    if (rendering == null || rendering.fields == null) {
      return;
    }

    this.rowSpacing = getItemLinkFieldValue(rendering.fields, 'rowSpacing', '');
    // first set theming options if selected
    this.contentOptions = getItemLinkFieldValue(
      rendering.fields,
      'backgroundTheme',
      ''
    );

    this.contentOptions +=
      ' ' + getItemLinkFieldValue(rendering.fields, 'textTheme', '');

    this.contentOptions +=
      ' ' + getItemLinkFieldValue(rendering.fields, 'contentSpacing', '');
  }
}
